// =================================================================================================
// >>> **HER HOME PAGE ART, LIVE FOR EVERYONE (ITEM HOME-GO, her go word 2026-10-01).** <<<
//
// The tap-area map moved HERE from `server/home-preview.js`, at its declaration, so the live home
// (the React page) and the owner preview read ONE map and cannot drift (R28/R29). Her art is the
// page: `her-home-v1-2752.webp` (from "new homepage.png") on desktop and `her-home-phone-v1-941.webp`
// (from "vertical homepage.png") on phones, both built by scripts/home-art-build.mjs and never
// rebuilt here. Every drawn button gets an invisible tap area at percentages of HER artwork's box.
//
// IMPORTS NOTHING, so the client bundle, the server and a `.mjs` gate all load it. It names no
// market string: the Truth button points at the HOUSE's own door (`HOME_READING_DOOR`), which the
// server resolves per seat through `server/truth-door.js` (her build-dark law: the bundle stays at zero).
// =================================================================================================

/** The house door the "Start Your Psychic Reading" button opens; the server answers it with a redirect. */
export const HOME_READING_DOOR = "/api/home/reading";

/** Where a seat the Truth gate refuses lands: the home, told "Coming soon". */
export const HOME_COMING_SOON_QUERY = "truth=coming-soon";

/** "Explore the Rooms": the house's existing rooms index, the room grid under her art (EXPLORE-ROOMS-Q1). */
export const HOME_ROOMS_ANCHOR = "rooms";

/** Her art, served publicly by its versioned file name (immutable, so it is cached hard). */
export const HOME_ART_FILES = Object.freeze({
  desktop: Object.freeze({ file: "her-home-v1-2752.webp", width: 2752, height: 1536 }),
  phone: Object.freeze({ file: "her-home-phone-v1-941.webp", width: 941, height: 1672 }),
});
export const HOME_ART_ROUTE = "/api/home-art/";

/**
 * The ONE breakpoint that picks both the art and its map. The `<picture>` source and the zone sets
 * read this same number, so the browser can never show her phone art under the desktop map.
 */
export const HOME_ART_PHONE_MAX = 760;

/**
 * >>> **EVERY BUTTON DRAWN IN HER DESKTOP ART, ITS WORDS EXACTLY AS DRAWN, AND THE PAGE IT OPENS.** <<<
 * Percentages of her 2752x1536 artwork's own box, measured off the file and corrected against the
 * rendered overlay side by side. `page` is the house page a tap opens (the SPA's own door, so My
 * Room keeps its sign-in-first rule); `to` is the real address, so a new tab works too.
 */
export const HOME_ART_ZONES = Object.freeze([
  { id: "explore-rooms", drawn: "Explore the Rooms", to: "/#rooms", page: "", pending: "EXPLORE-ROOMS-Q1", left: 14.4, top: 53.2, width: 20.1, height: 5.2 },
  { id: "human-design", drawn: "HUMAN DESIGN", to: "/human-design", page: "human-design", left: 3.7, top: 60.9, width: 17.8, height: 20.1 },
  { id: "tarot", drawn: "TAROT", to: "/tarot", page: "tarot", left: 22.4, top: 60.9, width: 17.8, height: 20.1 },
  { id: "numerology", drawn: "NUMEROLOGY", to: "/numerology", page: "numerology", left: 41.2, top: 60.9, width: 17.8, height: 20.1 },
  { id: "dreams", drawn: "DREAM INTERPRETATION", to: "/dreams", page: "dreams", left: 59.5, top: 60.9, width: 18.1, height: 20.1 },
  { id: "my-room", drawn: "MY ROOM", to: "/my-room", page: "my-room", left: 78.3, top: 60.9, width: 17.9, height: 20.1 },
  // Her Truth addition. The house door, resolved per seat by the server.
  { id: "truth", drawn: "Start Your Psychic Reading", to: "truth-door", page: "", left: 70.5, top: 86.0, width: 25.5, height: 8.2 },
]);

/**
 * >>> **HER PHONE DESIGN (`vertical homepage.png`, 941x1672).** <<< The SAME seven buttons, her phone
 * layout. Same ids and destinations as the desktop map, so a door means the same page at every
 * width; only where it sits differs.
 */
export const HOME_ART_ZONES_PHONE = Object.freeze([
  { id: "explore-rooms", drawn: "Explore the Rooms", to: "/#rooms", page: "", pending: "EXPLORE-ROOMS-Q1", left: 14.7, top: 31.5, width: 41.7, height: 3.9 },
  { id: "human-design", drawn: "HUMAN DESIGN", to: "/human-design", page: "human-design", left: 6.4, top: 48.3, width: 42.5, height: 12.0 },
  { id: "tarot", drawn: "TAROT", to: "/tarot", page: "tarot", left: 51.2, top: 48.3, width: 42.5, height: 12.0 },
  { id: "numerology", drawn: "NUMEROLOGY", to: "/numerology", page: "numerology", left: 6.4, top: 61.2, width: 42.5, height: 12.3 },
  { id: "dreams", drawn: "DREAM INTERPRETATION", to: "/dreams", page: "dreams", left: 51.2, top: 61.2, width: 42.5, height: 12.3 },
  { id: "my-room", drawn: "MY ROOM", to: "/my-room", page: "my-room", left: 6.4, top: 74.5, width: 87.4, height: 12.0 },
  { id: "truth", drawn: "Start Your Psychic Reading", to: "truth-door", page: "", left: 46.5, top: 94.3, width: 49.3, height: 3.8 },
]);

/** The address a zone's link carries. The Truth zone goes through the house door. */
export function homeZoneHref(zone, truthHref = HOME_READING_DOOR) {
  return zone.to === "truth-door" ? truthHref : zone.to;
}
